import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatSearchTermPipe',
    standalone: true
})
export class FormatSearchTermPipePipe implements PipeTransform {

    transform(baseString: string, searchTerm: string): string {
        return searchTerm ? baseString.replace(new RegExp(this.escapeRegexp(searchTerm), 'gi'), '<strong>$&</strong>') : baseString;
    }

    private escapeRegexp(queryToEscape: string): string {
        return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }
}
